import React from "react";
import PropTypes from "prop-types";
import "./InputField.scss";

const InputField = ({ label, as: Component = "input", ...props }) => (
  <div className="input-field">
    {label && <label htmlFor={props.id}>{label}</label>}
    {/* Use the provided component type (input or select) */}
    <Component {...props} />
  </div>
);

InputField.propTypes = {
  label: PropTypes.string,
  id: PropTypes.string.isRequired,
  as: PropTypes.elementType, // Default to 'input'
};

export default InputField;
